import { flexRender, Header } from "@tanstack/react-table";
import clsx from "clsx";

import { DataTableColumn } from "../DataTable";

export interface TDataGridTableHeadCellProps<TData, TValue> {
  header: Header<TData, TValue>;
  column?: DataTableColumn<TData>;
}

export const DataGridTableHeadCell = <TData, TValue>({
  header,
  column,
}: TDataGridTableHeadCellProps<TData, TValue>) => {
  return (
    <th
      key={header.id}
      colSpan={header.colSpan}
      style={{
        width: header.column.getSize(),
        textAlign: column?.align,
      }}
    >
      {header.column.columnDef.enableSorting ? (
        <div
          className={clsx(
            header.column.getCanSort() ? "cursor-pointer select-none" : "",
          )}
          onClick={header.column.getToggleSortingHandler()}
        >
          <span
            className={clsx("sort", {
              [`${header.column.getIsSorted()}`]: header.column.getIsSorted(),
            })}
          >
            <span className="sort-label">
              {flexRender(header.column.columnDef.header, header.getContext())}
            </span>
            <span className="sort-icon"></span>
          </span>
        </div>
      ) : (
        <span
          style={{
            fontSize: column?.headerFontSize,
            fontWeight: column?.headerFontWeight,
            color: column?.headerColor ?? "inherit",
          }}
        >
          {flexRender(header.column.columnDef.header, header.getContext())}
        </span>
      )}
    </th>
  );
};
